import * as React from 'react';
import { ButtonSecondary, CloseButton, ButtonPrimary, ElementLoader } from 'ui';
import styles from '../regenerate-aggregated-modal.scss';

export interface RegenerateAggregatedModalProps {
  translation?: any;
  onClose: () => void;
  fetchingRegenerateAggregated: boolean;
  executeRegenerateAggregatedEnv: () => void;
}

export class RegenerateAggregatedEnvModal extends React.PureComponent<RegenerateAggregatedModalProps, any> {
  public render() {
    const { fetchingRegenerateAggregated, translation } = this.props;

    return (
      <div className={`modal ${styles.regenerateAggregatedModal}`}>
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5>{translation.regenerate_aggregated_environmental_title}</h5>
              <CloseButton data-dismiss="modal" onClick={this.props.onClose} />
            </div>
            <div className={`modal-body ${styles.regenerateAggregatedModalBody}`}>
              {fetchingRegenerateAggregated ? <div className={styles.loader}>
                {<ElementLoader />}
              </div> : translation.regenerate_aggregated_environmental_description}
            </div>
            <div className={`modal-footer ${styles.regenerateAggregatedModalFooter}`}>
              <ButtonSecondary dataDismiss="modal" onClick={this.props.onClose} disabled={fetchingRegenerateAggregated}>
                {translation.regenerate_aggregated_cancel}
              </ButtonSecondary>
              <ButtonPrimary onClick={this.props.executeRegenerateAggregatedEnv} disabled={fetchingRegenerateAggregated}>
                {translation.regenerate_aggregated_submit_button}
              </ButtonPrimary>
            </div>
          </div>
        </div>
        <div className="modal-background" onClick={this.props.onClose} />
      </div>
    );
  }
}
